import {
  BlockGlyph,
  MarkerGlyph,
  AnnotationRow,
  AnnotationLabel,
  AnnotationDescription,
} from "./styles";

export interface VideoAnnotationProps {
  bgcolor?: React.CSSProperties["backgroundColor"];
  color: React.CSSProperties["color"];
  label: string;
  description: string;
  variant?: "circle" | "square";
}

const VideoAnnotation = ({
  bgcolor,
  color,
  label,
  description,
  variant = "circle",
}: VideoAnnotationProps) => {
  return (
    <AnnotationRow>
      <AnnotationLabel variant="left">
        {variant === "circle" ? (
          <MarkerGlyph
            sx={{
              backgroundColor: bgcolor,
              borderColor: color,
            }}
          />
        ) : (
          <BlockGlyph sx={{ backgroundColor: color }} />
        )}

        {label}
      </AnnotationLabel>
      <AnnotationDescription>{description}</AnnotationDescription>
    </AnnotationRow>
  );
};

export default VideoAnnotation;
